import config from "../config";
import axios from "axios";
import { toast } from "react-toastify";

const PincodeService = {
  getCityAndState: async function (pincode) {
    try {
      const response = await axios.get(
        `${config.apiUrl}/get-address/${pincode}`
      );
      return response.data.data;
    } catch (error) {
      toast.error("Pincode Not Found!", {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
      return;
    }
  },
};

export default PincodeService;
